import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/**
 * Render a flexible `icon` prop into a node. Accepts, in priority order:
 *   - a ready React element/node    -> returned as-is
 *   - a component type (function)   -> instantiated as <Icon />
 *   - a FontAwesome icon definition -> wrapped in <FontAwesomeIcon />
 * Returns null for a nullish icon. The single icon-rendering helper shared by
 * every ui component (and the maintenance anchors) that take an `icon`.
 */
const iconNode = icon => {
  if (icon == null) return null;
  if (React.isValidElement(icon)) return icon;
  if (typeof icon === 'function') {
    const Icon = icon;
    return <Icon />;
  }
  return <FontAwesomeIcon icon={icon} />;
};

export default iconNode;
